/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Flyerneedsqrdata3Inputs */

const en_flyerneedsqrdata3 = /** @type {(inputs: Flyerneedsqrdata3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter a link or text for the QR code.`)
};

const de_flyerneedsqrdata3 = /** @type {(inputs: Flyerneedsqrdata3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gib einen Link oder Text für den QR-Code ein.`)
};

/**
* | output |
* | --- |
* | "Enter a link or text for the QR code." |
*
* @param {Flyerneedsqrdata3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const flyerneedsqrdata3 = /** @type {((inputs?: Flyerneedsqrdata3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Flyerneedsqrdata3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_flyerneedsqrdata3(inputs)
	return de_flyerneedsqrdata3(inputs)
});
export { flyerneedsqrdata3 as "flyerNeedsQrData" }